import { cn } from '@tebuto/lib/utils'

export default function LargeText({
    children,
    className = '',
    ...rest
}: { children?: React.ReactNode } & React.HTMLAttributes<HTMLParagraphElement>) {
    return (
        <p {...rest} className={cn('md:text-base text-sm text-foreground', className)}>
            {children}
        </p>
    )
}
